import React from 'react'
import { formatDate, formatNumber } from '../../shared/constants'
import StatusTable from './StatusTable'

export default function SalesStatus() {
  const tableData = (item, tableHeadings) => {
    let tempData = []
    tableHeadings &&
      tableHeadings.forEach((val) => {
        console.log({ val })
        let statusEnum = val !== 'status' ? { value: item[val] } : { status: item[val], type: 'STATUS_ENUM' }
        tempData.push(statusEnum)
      })
    return tempData
  }
  return <StatusTable key="Sales" tableData={tableData} module="SALES" />
}
